import { forwardRef, ForwardRefExoticComponent } from "react";

import { Button as MagneticButton } from "@magnetic/button";

import { ButtonProps } from "./types";

/**
 * This adds a requirement of name or id prop
 * for all buttons. It should help automation
 * tools identify buttons more easily.
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props: ButtonProps, ref) => {
    return <MagneticButton ref={ref} {...props} />;
  }
) as ForwardRefExoticComponent<ButtonProps> & {
  Group: typeof MagneticButton.Group;
};
// 3. Add display name for better debugging
Button.displayName = "Button";
// 4. Attach static properties
Button.Group = MagneticButton.Group;
